module.exports = __webpack_public_path__ + "static/logos/icon-facebook-ebe8d74324b3dece1e95c5af09f841a5.svg";